import { Easing } from 'framer-motion';

const PULSE_PERIOD = 0.0691;
const PULSE_SNAP = 0.0002;
const PULSE_COUNT = 12;

export const buildScaleKeyframes = (phase: number) => {
  const values = [0.01, 0.01];
  const times = [0, phase];
  const ease: Easing[] = ['linear'];
  for (let i = 0; i < PULSE_COUNT; i += 1) {
    const end = phase + (i + 1) * PULSE_PERIOD;
    times.push(end - PULSE_SNAP, end);
    values.push(1, 0.01);
    ease.push('easeOut', 'linear');
  }
  times.push(1);
  values.push(0.01);
  ease.push('linear');
  return { values, times, ease };
};

export const buildOpacityKeyframes = (phase: number) => {
  const values = [0, 0];
  const times = [0, phase];
  const ease: Easing[] = ['linear'];

  for (let i = 0; i < PULSE_COUNT; i += 1) {
    const start = phase + i * PULSE_PERIOD;
    const end = start + PULSE_PERIOD;
    times.push(start + PULSE_SNAP, start + PULSE_PERIOD / 2, end);
    values.push(1, 1, 0);
    ease.push('linear', 'easeOut', 'linear');
  }

  times.push(1);
  values.push(0);
  ease.push('linear');
  return { values, times, ease };
};
